import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Download, ListOrdered } from "lucide-react";
import { API } from "../../../config";
import { formatEur } from "../../../pages/SmsCreditPage";

const KIND = { topup: "Ricarica", gift: "Omaggio", adjustment: "Rettifica", debit: "SMS", debit_refunded: "SMS non inviato (rimborsato)" };
const TYPE = { otp: "OTP firma", welcome: "Benvenuto", post_signature: "Link card", dealer_mfa: "Codice accesso concessionario" };

export const SmsLedgerTable = ({ reloadKey }) => {
  const [filters, setFilters] = useState({ date_from: "", date_to: "", kind: "all" });
  const [items, setItems] = useState([]);

  const params = () => Object.fromEntries(Object.entries(filters).filter(([, v]) => v));

  useEffect(() => {
    axios.get(`${API}/admin/sms-credit/ledger`, { params: params() })
      .then((r) => setItems(r.data.items))
      .catch(() => toast.error("Impossibile caricare lo storico"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, reloadKey]);

  const download = async () => {
    try {
      const r = await axios.get(`${API}/admin/sms-credit/statement.csv`, { params: params(), responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = "estratto_credito_sms.csv"; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error("Download estratto conto non riuscito"); }
  };

  const set = (k) => (e) => setFilters((f) => ({ ...f, [k]: e.target.value }));

  return (
    <div className="bg-[#111] border border-gray-800 rounded-2xl p-6" data-testid="sms-ledger">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
        <p className="flex items-center gap-2 text-white font-semibold"><ListOrdered size={18} /> Storico movimenti</p>
        <div className="flex flex-wrap items-center gap-2">
          <input type="date" value={filters.date_from} onChange={set("date_from")} className="bg-[#0a0a0a] border border-gray-700 rounded-xl px-3 py-2 text-white outline-none focus:border-gray-500 text-sm" data-testid="sms-ledger-from" />
          <input type="date" value={filters.date_to} onChange={set("date_to")} className="bg-[#0a0a0a] border border-gray-700 rounded-xl px-3 py-2 text-white outline-none focus:border-gray-500 text-sm" data-testid="sms-ledger-to" />
          <select value={filters.kind} onChange={set("kind")} className="bg-[#0a0a0a] border border-gray-700 rounded-xl px-3 py-2 text-white outline-none focus:border-gray-500 text-sm" data-testid="sms-ledger-kind">
            <option value="all">Tutti</option>
            <option value="credits">Ricariche e rettifiche</option>
            <option value="debits">SMS inviati</option>
          </select>
          <button onClick={download} className="btn-lojack-outline text-sm flex items-center gap-1" data-testid="sms-statement-csv">
            <Download size={14} /> Estratto conto CSV
          </button>
        </div>
      </div>
      <div className="overflow-x-auto max-h-[420px]">
        <table className="w-full text-sm">
          <thead className="text-xs uppercase text-gray-400 border-b border-gray-800">
            <tr><th className="text-left py-2">Data</th><th className="text-left">Movimento</th><th className="text-left">Dettaglio</th><th className="text-right">Importo</th><th className="text-right">Saldo</th></tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={5} className="py-6 text-center text-gray-500" data-testid="sms-ledger-empty">Nessun movimento nel periodo</td></tr>}
            {items.map((r) => (
              <tr key={r.id} className="border-b border-gray-900" data-testid={`sms-ledger-row-${r.id}`}>
                <td className="py-2 text-gray-300 whitespace-nowrap">{new Date(r.created_at).toLocaleString("it-IT")}</td>
                <td className="text-white">{KIND[r.kind] || r.kind}</td>
                <td className="text-gray-400">
                  {r.sms_type ? `${TYPE[r.sms_type] || r.sms_type} · ${r.country} · ${r.segments} SMS × ${formatEur(r.unit_price_eur, 3)}` : r.note}
                </td>
                <td className={`text-right font-mono ${r.kind === "debit_refunded" ? "text-gray-500 line-through" : r.amount_eur < 0 ? "text-red-300" : "text-green-400"}`}>{formatEur(r.amount_eur, 3)}</td>
                <td className="text-right font-mono text-gray-300">{formatEur(r.balance_after_eur, 3)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
